<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="1200px"
    top="5vh"
    center
    @close="handleClose">

    <el-form  label-position="left"   :model="form" size="small">
      <el-form-item  label="所需领域" v-if="title=='成果领域查看'">
        <el-select filterable v-model="form.scope" clearable placeholder="请选择所属领域" size="small"  @change="handleSelectChange">
              <el-option :label="item.title" :value="item.id" v-for="(item,index) in dictList" :key="index"></el-option>

              </el-select>
      </el-form-item>
      <el-form-item  label="推荐单位" v-if="title=='推荐单位查看'">
        <el-select filterable v-model="form.orgRec_id" clearable placeholder="请选择推荐单位" size="small"  @change="handleSelectChange">
              <el-option :label="item.user_name" :value="item.id" v-for="(item,index) in unitList" :key="index"></el-option>

              </el-select>
      </el-form-item>

      <el-form-item  label="推荐个人" v-if="title=='推荐个人查看'">
        <el-select filterable v-model="form.personRec_id" clearable placeholder="请选择推荐个人" size="small"  @change="handleSelectChange">
              <el-option :label="item.user_name" :value="item.id" v-for="(item,index) in individualList" :key="index"></el-option>

              </el-select>
      </el-form-item>

      <el-form-item  label="项目地区" v-if="title=='成果地区查看'">
        <el-select filterable v-model="form.org_province_name" clearable placeholder="请选择项目地区" size="small"  @change="handleSelectChange">
              <el-option :label="item.name" :value="item.name" v-for="(item,index) in provinceList" :key="index"></el-option>

              </el-select>
      </el-form-item>
    </el-form>
    <el-table
      :data="homeProjectData"
      style="width: 100%"
      class="custom-table">
      <el-table-column prop="optimize_name" label="发布会科技成果名称" align="center"> </el-table-column>
      <el-table-column prop="org_name" width="280" label="成果申报单位" align="center"> </el-table-column>
      <el-table-column prop="date" width="200"  align="center" >
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleRow(scope.row,'look')">项目预览</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageBox">
        <el-pagination @size-change="sizePagination" @current-change="currentPagination" :page-size="form.pageSize"
          background layout="prev, pager, next" :total="projectTotal">
        </el-pagination>
      </div>
      <MaskDialog :visible.sync="maskDialogVisible" :title="maskDialogTitle" :item="currentItem">
      </MaskDialog>
  </el-dialog>
  
</template>

<script>
import { getSelectList, getAchievementList } from '@/api'
import MaskDialog from './MaskDialog.vue'
export default {
  name: 'PopupList',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    gameId: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    dialogType: {
      type: String,
      default: ''
    }
  },
  components: {
    MaskDialog,
  },
  data() {
    return {
      maskDialogVisible: false,
      maskDialogTitle: '成果详情',
      currentItem: {},
      provinceList:[],
      individualList:[],
      dictList:[],

      projectTotal: 0,
      homeProjectData:[],
      tableData: [],
      unitList: [],
      form: {
        scope:'',
        orgRec_id:'',
        personRec_id:'',
        org_province_name:'',
        currPage:1,
        pageSize:10
      },
      loading: false

    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.getSelectData()
        this.getTableList()
      }
    }
  },
  methods: {
    handleRow(item) {
      this.currentItem = item;
      this.maskDialogVisible = true;
    },
    sizePagination(e) {
      this.form.currPage = e
      this.getTableList()
    },
    currentPagination(e) {
      this.form.currPage = e
      this.getTableList()
    },
    // 获取下拉选择数据
    async getSelectData() {
      this.form={
        scope:'',
        orgRec_id:'',
        personRec_id:'',
        org_province_name:'',
        currPage:1,
        pageSize:10
      }
      switch (this.title) {
        case '成果领域查看':
        this.$API.getDict({ pid: 66 }).then(res => {
          this.dictList = res.data
        })
          break;
        case '推荐单位查看':
        this.$API.getLoginRecommendList({ identify: 1 }).then(res => {
        this.unitList = res.data
      })
          break;
        case '推荐个人查看':
        this.$API.getLoginRecommendList({ identify: 2 }).then(res => {
          this.individualList = res.data
        })
          break;
        case '成果地区查看':
        this.$API.getProvinceList({ pid: 0 }).then(res => {
        this.provinceList = res.data
      })
          break;
      }
    },
    // 获取表格列表数据
    async getTableList() {
      this.loading = true
      try {
        this.form.game_id = this.gameId
        this.$API.getHomeProject(this.form).then(res => {
        this.homeProjectData = res.data.list;
        this.projectTotal = res.data.pageInfo.allRows;
      })
      } catch (error) {
        console.error('获取列表数据失败:', error)
      } finally {
        this.loading = false
      }
    },
    handleSelectChange() {
      this.getTableList()
    },
    handleItemClick(item) {
      this.$emit('select', item);
      this.$emit('update:visible', false);
    },
    handleClose() {
      this.$emit('update:visible', false);
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.pageBox {
  width: 100%;
  display: flex;
  justify-content: end;
  cursor: pointer;
  padding-top: 10px;
}
.dialog-list {
  max-height: 400px;
  overflow-y: auto;
}
.dialog-item {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  font-size: 16px;
  color: #333;
  transition: all 0.3s;
}
.dialog-item:hover {
  background-color: #e6f7ff;
  color: #1890FF;
  padding-left: 30px;
}
.dialog-item:last-child {
  border-bottom: none;
}
</style>
